import { createContext, useMemo, useContext, useState } from "react";
import { useAccount, useSwitchChain } from "wagmi";

const StateContext = createContext();

export const StateContextProvider = ({ children }) => {

    const { chains } = useSwitchChain()
    const { isConnected } = useAccount();
    const [chainId, setChainId] = useState(localStorage.getItem("chainId") || '')
    const [donateModalShow, setDonateModalShow] = useState(false)
    const [currentProject, setCurrentProject] = useState(null)

    const isValid = useMemo(() => {
        return isConnected && chains?.some(item => item?.id === chainId);
    }, [isConnected, chains, chainId]);

    const value = useMemo(() => {
        return {
            isValid,
            chainId,
            setChainId,
            donateModalShow,
            setDonateModalShow,
            currentProject, 
            setCurrentProject
        };
    }, [isValid, chainId, setChainId, donateModalShow, setDonateModalShow, currentProject, setCurrentProject]);

    return (
        <StateContext.Provider value={value}>
            {children}
        </StateContext.Provider>
    );
};

export const useStateContext = () => useContext(StateContext);
